export default "__VITE_ASSET__3f846a45__"